import { useState, type ReactNode } from 'react'
import { NavLink, useLocation, useParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import { useServizi } from '../servizi/ServiziProvider'
import { permessiDaToken } from '../lib/claims'
import { useDatiQuadro } from '../home/useDatiQuadro'
import { quadro, righeDichiarazioniElenco } from '../home/quadro'
import { ANNO_IMPOSTA } from '../lib/anno-imposta'
import { BarraSuperiore } from './BarraSuperiore'
import { Icona } from './Marchio'
import { ICONE } from './icone'
import { menuVisibile, type VoceMenu } from './menu'

export function Layout({ children }: { children: ReactNode }) {
  const { sessione } = useAuth()
  const { attivi } = useServizi()
  const { idPartner } = useParams()
  const permessi = permessiDaToken(sessione?.access_token)
  const gruppi = menuVisibile(permessi, attivi)
  const base = `/cliente/${idPartner}`
  // Su mobile il menu si apre dal pulsante della barra e si chiude a ogni cambio di pagina.
  const [aperto, setAperto] = useState(false)
  const { pathname } = useLocation()
  const [ultimo, setUltimo] = useState(pathname)
  if (ultimo !== pathname) {
    setUltimo(pathname)
    setAperto(false)
  }

  // Stesse letture del cruscotto (cache condivisa): il numero rosso accanto alla voce.
  const { scadenze, green, soglia, termini, dichiarazioni } = useDatiQuadro(Number(idPartner), {
    scadenze: permessi.includes('scadenziari'),
    produzione: permessi.includes('praticheenergia_green'),
    dichiarazioni: permessi.includes('dichiarazioni_ad1'),
  })
  const q = quadro(scadenze, green, soglia)
  const dichiarazioniInRitardo = righeDichiarazioniElenco(dichiarazioni, termini, ANNO_IMPOSTA).filter((d) => d.tono === 'rosso').length
  const conteggi = { scadute: q.scadute, anomalie: q.sottoSoglia, dichiarazioni: dichiarazioniInRitardo }

  const rotta = (v: VoceMenu) => (v.rotta ? `${base}/${v.rotta}` : `${base}/`)
  const voci = (elenco: VoceMenu[]) => (
    <ul>
      {elenco.map((v) => {
        const n = v.conteggio ? conteggi[v.conteggio] : 0
        return (
          <li key={v.etichetta}>
            <NavLink to={rotta(v)} end={!v.rotta}>
              {v.icona && <Icona d={ICONE[v.icona]} />}
              <span className="voce-etichetta">{v.etichetta}</span>
              {v.daAttivare ? (
                <span className="badge-attiva">da attivare</span>
              ) : (
                n > 0 && <span className="badge-conteggio">{n}</span>
              )}
            </NavLink>
          </li>
        )
      })}
    </ul>
  )

  return (
    <div className={aperto ? 'layout menu-aperto' : 'layout'}>
      <BarraSuperiore onMenu={() => setAperto((a) => !a)} />
      <div className="layout-corpo">
        <nav aria-label="Navigazione principale">
          {gruppi.map((g, i) =>
            g.comprimibile ? (
              <details key={i} className="gruppo-comprimibile" open={g.voci.some((v) => pathname.startsWith(rotta(v))) || undefined}>
                <summary>
                  {g.icona && <Icona d={ICONE[g.icona]} />}
                  <span className="voce-etichetta">{g.titolo}</span>
                </summary>
                {voci(g.voci)}
              </details>
            ) : (
              <section key={i}>
                {g.titolo && <h2>{g.titolo}</h2>}
                {voci(g.voci)}
              </section>
            ),
          )}
        </nav>
        <main>{children}</main>
      </div>
    </div>
  )
}
